import { settings } from '@/api/config';
import axios from 'axios';
import { getInitData } from '@/utils/getInitData';

export const getBalance = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/users/balance?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};

export const postBalance = async () => {
  const tg = window?.Telegram?.WebApp;
  const encodedInitData = encodeURIComponent(getInitData());
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  const response = await axios.post(
    `${settings.url}api/users/withdraw/application?initData=${encodedInitData}`,
  );
  return response.data;
};
